<div #componentContainer class="h-100"></div>
